import { create } from "zustand"

interface UIBuilderLocaleStore {
  locale: string
  setLocale: (locale: string) => void
}

export const useUIBuilderLocaleStore = create<UIBuilderLocaleStore>(set => ({
  locale: "vi",
  setLocale: locale => set({ locale }),
}))
